import { chooseAOrB } from 'common/helper/choose/a-or-b';

/**
 * Returns toggle function between string or empty string
 *
 * @param str - string to toggle
 */
export const stringToggle = (str: string) => chooseAOrB(str, '');
